import { render, staticRenderFns } from "./ShoppingCartTable.vue?vue&type=template&id=6940340e&scoped=true"
import script from "./ShoppingCartTable.vue?vue&type=script&lang=js"
export * from "./ShoppingCartTable.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartTable.vue?vue&type=style&index=0&id=6940340e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6940340e",
  null
  
)

export default component.exports